import { Product } from "features/ProductReel/types";
import { toEuroNumber } from "features/utils";
export type CartData = {
  product: Product;
  installation: boolean;
};

function justNumbers(string: string) {
  var numsStr = string.replace(/[^0-9]/g, "");
  return parseInt(numsStr);
}
export const getInstallationPrice = (
  power_btu: string,
  installationPrices: any,
  type: string
) => {
  let res: any = {};
  const power = justNumbers(power_btu);

  res = installationPrices.find(
    (item: any) =>
      item.airConditionType === type &&
      item.from_power <= power &&
      power <= item.to_power
  );

  if (!res) {
    res = installationPrices.find(
      (item: any) =>
        item.airConditionType === type && !item.from_power && !item.to_power
    );
    if (!res) {
      //default installation price for all
      res = installationPrices.find(
        (item: any) =>
          item.from_power <= power &&
          power <= item.to_power &&
          !item.airConditionType
      );
    }
  }
  return res ? res.price : 0;
};

export const getInstallationPriceEur = (
  power_btu: string,
  installationPrices: any,
  type: string
) => {
  const priceBgn = getInstallationPrice(power_btu, installationPrices, type);
  const power = justNumbers(power_btu);
  const installation = installationPrices.find(
    (item: any) =>
      item.airConditionType === type &&
      item.from_power <= power &&
      power <= item.to_power
  ) ?? installationPrices.find(
    (item: any) =>
      item.airConditionType === type && !item.from_power && !item.to_power
  ) ?? installationPrices.find(
    (item: any) =>
      item.from_power <= power &&
      power <= item.to_power &&
      !item.airConditionType
  );

  return installation?.price_eur ?? toEuroNumber(priceBgn) ?? 0;
};

export const getProductWithInstallationPrice = (
  product: Product,
  installation: boolean,
  installationPrices: any,
  type: string
) => {
  const price = getInstallationPrice(
    product.power_btu,
    installationPrices,
    type
  );
  const installationPrice = installation ? price : -price;
  const promoPriceD = product.price_promotion
    ? product.price_promotion + installationPrice
    : undefined;
  const priceD = product.price + installationPrice;
  const priceEur = toEuroNumber(priceD) ?? 0;
  const promoPriceEur = promoPriceD === undefined
    ? undefined
    : toEuroNumber(promoPriceD) ?? 0;

  const updatedProduct = {
    ...product,
    ...{
      price: priceD,
      price_eur: priceEur,
      price_promotion: promoPriceD,
      price_promotion_eur: promoPriceEur,
    },
  };
  return updatedProduct;
};
